import { DynamicAutocompleteField } from "components/formFields/DynamicAutocompleteField";

import { fetchClasses } from "services/utility/class";

import { useClasses } from "hooks/useClasses";

export function ClassFilter(props) {
  const { value, onValueChange, name, label } = props;
  const { classes, classesCount } = useClasses();

  return (
    <DynamicAutocompleteField
      name={name}
      label={label}
      options={classes}
      optionsCount={classesCount}
      fetchFn={fetchClasses}
      value={value}
      onValueChange={onValueChange}
    />
  );
}
